const assessmentReviuw = [
    {
      ['correct-option']: "",
      description: "",
      options: ['1','2','3','4','5'],
      question: "On a scale of 1-5, how would you rate the level of difficulty of this Crash Course assessments? (1: Very Easy to 5: Very Difficult).",
      uuid: "1",
      type: "radio"
    },
    {
      ['correct-option']: "",
      description: "",
      options: ['1','2','3','4','5'],
      question: "On a scale of 1-5, how would you rate the difficulty of this crash course? (1: Very Easy to 5: Very Difficult).",
      uuid: "2",
      type: "radio"
    },
    {
      ['correct-option']: "",
      description: "",
      options: ['1','2','3','4','5'],
      question: "How likely are you to recommend this crash course to others? (1: Not at all likely to 5: Extremely likely).",
      uuid: "3",
      type: "radio"
    },
    {
      ['correct-option']: "",
      description: "",
      options: ['1','2','3','4','5'],
      question: "How well did this course meet your learning expectations? (1: Not at all to 5: Exceeded expectations).",
      uuid: "4",
      type: "radio"
    },
    {
      ['correct-option']: "",
      description: "",
      options: [],
      question: "What aspects of the crash course did you find most valuable or engaging?",
      uuid: "5",
      type: "text"
    },
    {
      ['correct-option']: "",
      description: "",
      options: [],
      question: "In what ways could this crash course be improved?",
      uuid: "6",
      type: "text"
    },
    {
      ['correct-option']: "",
      description: "",
      options: [],
      question: "What additional topics or areas would you like to see covered in future courses?",
      uuid: "7",
      type: "text"
    },
]

export default assessmentReviuw;